import DepositsListItem from "pages/deposits/ListItem";
import WidgetList from "pages/desktop/widgets/WidgetList";
import Box from "pages/_components/Box";
import Button from "pages/_components/Button";
import WithPermissions from "pages/_components/WithPermissions";
import { node, shape } from "prop-types";
import React, { Component } from "react";
import * as i18nUtils from "util/i18n";
import * as config from "util/config";
import WidgetHeader from "./_components/WidgetHeader";

class Deposits extends Component {
    static propTypes = {
        closeButton: node,
        draggableItemProps: shape({}).isRequired,
    };

    static defaultProps = {
        closeButton: null,
    };

    render() {
        const { closeButton, draggableItemProps } = this.props;
        const uiAutomationProp = { "data-ui-automation": "widgetDeposits" };
        const itemsToShowButton = Number(config.get("widgets.product.maxToShow"));

        return (
            <WidgetList item={DepositsListItem} keyExtractor={(item) => item.idProduct} name="deposits">
                {(list, listLenght) => (
                    <section
                        className="widget"
                        {...uiAutomationProp}
                        {...draggableItemProps}
                        aria-roledescription={i18nUtils.get("desktop.widgets.message.roleDescription")}>
                        <WidgetHeader title={i18nUtils.get("menu.deposits")} action={closeButton} />
                        {list}
                        <WithPermissions permissions={["deposits"]}>
                            <Box display="flex" alignX="center" fullWidth flex1 className="px-md-3">
                                {listLenght > itemsToShowButton ? (
                                    <Button
                                        className="btn-widget"
                                        href="/deposits"
                                        label="widgets.deposits.myDeposits"
                                        bsStyle="link"
                                    />
                                ) : null}
                            </Box>
                        </WithPermissions>
                        <div className="overlay" />
                    </section>
                )}
            </WidgetList>
        );
    }
}

export default Deposits;
